import React from 'react';

const WorkProcessTwo = () => {
  return (
    <>
      <section className='work-process ptb-120 bg-dark text-white'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-md-10 col-lg-6'>
              <div className='section-heading text-center' data-aos='fade-up'>
                <h2>We Follow Our Work Process</h2>
                <p>
                  Conveniently mesh cooperative services via magnetic
                  outsourcing. Dynamically grow value whereas accurate
                  e-commerce parallel quality vectors.
                </p>
              </div>
            </div>
          </div>
          <div className='row d-flex align-items-center'>
            <div className='col-md-6 col-lg-3'>
              <div
                className='
                  process-card-two
                  text-center
                  px-4
                  py-lg-5
                  py-4
                  rounded-custom
                '
                data-aos='fade-up'
                data-aos-delay='50'
              >
                <div
                  className='
                    process-icon
                    border border-light
                    bg-custom-light
                    rounded-custom
                    p-3
                  '
                >
                  <i className='fad fa-folder-tree fa-2x'></i>
                </div>
                <h3 className='h5'>Research</h3>
                <p className='mb-0'>
                Progressively benchmark for the prospective results relationships.
                </p>
              </div>
            </div>
            <div className='col-md-6 col-lg-3'>
              <div
                className='
                  process-card-two
                  text-center
                  px-4
                  py-lg-5
                  py-4
                  rounded-custom
                '
                data-aos='fade-up'
                data-aos-delay='100'
              >
                <div
                  className='
                    process-icon
                    border border-light
                    bg-custom-light
                    rounded-custom
                    p-3
                  '
                >
                  <i className='fad fa-bezier-curve fa-2x'></i>
                </div>
                <h3 className='h5'>Designing</h3>
                <p className='mb-0'>
                Efficiently evisculate an grow your of mindshare through.
                </p>
              </div>
            </div>
            <div className='col-md-6 col-lg-3'>
              <div
                className='
                  process-card-two
                  text-center
                  px-4
                  py-lg-5
                  py-4
                  rounded-custom
                '
                data-aos='fade-up'
                data-aos-delay='150'
              >
                <div
                  className='
                    process-icon
                    border border-light
                    bg-custom-light
                    rounded-custom
                    p-3
                  '
                >
                  <i className='fad fa-layer-group fa-2x'></i>
                </div>
                <h3 className='h5'>Building</h3>
                <p className='mb-0'>
                Credibly maintain magnetic partnerships whereas users.
                </p>
              </div>
            </div>
            <div className='col-md-6 col-lg-3'>
              <div
                className='
                  process-card-two
                  text-center
                  px-4
                  py-lg-5
                  py-4
                  rounded-custom
                '
                data-aos='fade-up'
                data-aos-delay='200'
              >
                <div
                  className='
                    process-icon
                    border border-light
                    bg-custom-light
                    rounded-custom
                    p-3
                  '
                >
                  <i className='fad fa-truck fa-2x'></i>
                </div>
                <h3 className='h5'>Deliver</h3>
                <p className='mb-0'>
                Rapidiously for enterprise-wide niche markets communities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WorkProcessTwo;
